(function(){
    'use strict';

    angular
    .module('appback')
    .controller('PizarraContoller', PizarraContoller)
 
    PizarraContoller.$inject = ["socket","PizarraService","$http","$timeout","$uibModal", "$log", "$document","$sce","Upload"];
              
    function PizarraContoller(socket,PizarraService,$http,$timeout,$uibModal, $log, $document,$sce,Upload)
    {                         
        var vm = this;

        vm.user_id = false;
        vm.cartaModal = false;
        vm.todasCartas = [];
        vm.pizarras = { 
            'pendientes' : { 
                id: 5378829,
                items:[], 
                dragging:false 
            },
            'proceso': { 
                id: 5378830,
                items: [],
                dragging:false 
            },
            'finalizadas': {
                id: 5378831,
                items: [],
                dragging : false
            },
            'archivadas': {
                id: 5378832,
                items: [],
                dragging : false
            }
        };

        socket.on("user:listado",function(data){
            //console.log("user:listado",data);
        })

        socket.on("pizarra:nuevacarta",function(data){
            console.log("pizarra:nuevacarta",data);
            vm.actualizarCarta(data.carta,data.carta.estadopizarra_id);
        })

        socket.on("pizarra:modifycarta",function(data){
            //console.log("pizarra:modifycarta",data);
            vm.checkCartaModify(data.carta);
        })

        vm.init = function(username){
          vm.user_id = username;
        	PizarraService.getPizarra(function(data){
                console.log("data",data);
                vm.todasCartas = data.misCartas;
                vm.misCategoriasSeguidor = data.misCategoriasSeguidor;
        		vm.misCategorias = data.misCategorias;
                vm.pizarras['pendientes'].items = data.cartasPendientes;
                vm.pizarras['proceso'].items = data.cartasEnProceso;
                vm.pizarras['finalizadas'].items = data.cartasFinalizadas;

                //vm.ordenarPizarra();
        	})
	    }

        vm.addComentario = function(item){
            PizarraService.addComentario(item,function(data){
                vm.checkCartaModify(data.carta);
               socket.emit('pizarra:modifycarta', {carta:data.carta});
                
            })
        }

        vm.editarCarta = function(item){
            vm.addCarta(item);
        }

        vm.soySeguidoroCreador = function(carta){
            var res = false;
            if(!angular.isArray(carta.seguida_user_id)){
                if(typeof(carta.seguida_user_id)!='undefined'){
                    carta.seguida_user_id = carta.seguida_user_id.toString();
                    //console.log(carta.seguida_user_id);
                    carta.seguida_user_id = carta.seguida_user_id.split(",");
                }else{
                    carta.seguida_user_id = [];
                }
            }
            if((carta.seguida_user_id.length>0 && (carta.seguida_user_id.indexOf(""+vm.user_id) !== -1 || carta.seguida_user_id.indexOf(vm.user_id) !== -1)) || carta.userby_id==vm.user_id) {
                res = true;
            }
            return res;
        }

        vm.checkCartaModify = function(carta){
            vm.actualizarCarta(carta,carta.estadopizarra_id);
        }

        vm.esVisibleParaMi = function(carta){
            var res = false;
            var categorias_ids = [];
            for(var cont=0;cont<vm.misCategorias.length;cont++){
                categorias_ids.push(""+vm.misCategorias[cont].id);
            }
            if(categorias_ids.indexOf(""+carta.categoriapizarra_id) !== -1 || carta.user_id==vm.user_id) {
                res = true;
            }
            return res;
        }

        vm.getNameListado = function(listado_id){
            var res = false;
            console.log("pizarras",vm.pizarras,"listado_id",listado_id);
            Object.keys(vm.pizarras).forEach(function(key) {
                if(vm.pizarras[key].id==listado_id){
                    res = key;
                }
            });
            return res;
        }

       vm.getSelectedItemsIncluding = function(list, item) {
        //console.log("inc");
          item.selected = true;
          return list.items.filter(function(item) { return item.selected; });
        };

        vm.soySeguidoroCategoria = function(carta){
            var res = false;
            if(typeof(carta.categoriapizarra_id) != 'undefined' && carta.categoriapizarra_id!=null){
                for(var cont=0 ;cont<vm.misCategoriasSeguidor.length && !res;cont++){
                  if (vm.misCategoriasSeguidor.indexOf(carta.categoriapizarra_id) !== -1) {
                    res = true;
                  }
                }
            }
            return res;
        }

        vm.actualizarCarta = function(carta,estado){
            var estado_old = false;
            var cont_old = false;
            for(var cont=0;cont<vm.pizarras['pendientes'].items.length;cont++){
                if(vm.pizarras['pendientes'].items[cont].id == carta.id){
                    estado_old = vm.pizarras['pendientes'].items[cont].estadopizarra_id;
                    vm.pizarras['pendientes'].items[cont] = carta;
                    cont_old = cont;
                }
            }
            for(var cont=0;cont<vm.pizarras['proceso'].items.length;cont++){
                if(vm.pizarras['proceso'].items[cont].id == carta.id){
                    estado_old = vm.pizarras['proceso'].items[cont].estadopizarra_id;
                    vm.pizarras['proceso'].items[cont] = carta;
                    cont_old = cont;
                }
            }
            for(var cont=0;cont<vm.pizarras['finalizadas'].items.length;cont++){
                if(vm.pizarras['finalizadas'].items[cont].id == carta.id){
                    estado_old = vm.pizarras['finalizadas'].items[cont].estadopizarra_id;
                    vm.pizarras['finalizadas'].items[cont] = carta;
                    cont_old = cont;
                }
            }

            var existeCarta = false;
           for(var cont=0;cont<vm.todasCartas.length;cont++){
                if(vm.todasCartas[cont].id == carta.id){
                    vm.todasCartas[cont] = carta;
                    existeCarta = true;
                }
            }

            if(!existeCarta){
                if(vm.soySeguidoroCreador(carta) || vm.soySeguidoroCategoria(carta)){
                    vm.todasCartas.push(carta);
                }
            }

            if(typeof(estado)!='undefined' && vm.esVisibleParaMi(carta)){
                if(estado_old!=estado){
                    if(cont_old!==false){
                        vm.pizarras[vm.getNameListado(estado_old)].items.splice(cont_old,1);
                    }
                    vm.pizarras[vm.getNameListado(estado)].items.push(angular.copy(carta));
                }else{
                    vm.pizarras[vm.getNameListado(estado_old)].items[cont_old] = carta;
                }
            }
        }

        vm.cambiarEstado = function(carta,estado){
            PizarraService.cambiarEstado(carta,estado,function(data){
                vm.actualizarCarta(data.carta,estado);
                socket.emit('pizarra:modifycarta', {carta:data.carta});
            })
        }

        vm.onDragstart = function(list, event) {
           list.dragging = true;
        };

        vm.onMoved = function(list) {
          //console.log("moved",list);
          list.items = list.items.filter(function(item) { 
            //console.log("item",item);
            return !item.selected; 
            });
        };

        
        vm.onDrop = function(list, items, index, estado) {
          console.log("onDrop",list,items,index,estado);
          PizarraService.cambiarEstado(items[0],estado,function(data){
               console.log("data cambiar estado",data);
               vm.actualizarCarta(data.carta);
               socket.emit('pizarra:modifycarta', {carta:data.carta});
               
            })
          angular.forEach(items, function(item) { item.selected = false; });
          list.items = list.items.slice(0, index)
                      .concat(items)
                      .concat(list.items.slice(index));
          return true;
        }

        vm.onDropProceso = function(list, items, index, estado) {
         //console.log("list",list);
          //console.log("items",items);


            PizarraService.cambiarEstado(items[0],estado,function(data){
                vm.actualizarCarta(data.carta);
                socket.emit('pizarra:modifycarta', {carta:data.carta});
            })

          angular.forEach(items, function(item) { item.selected = false; });
          list.items = list.items.slice(0, index)
                      .concat(items)
                      .concat(list.items.slice(index));
            //console.log("drop",list.items);
          return true;
        }


        vm.onDropFin = function(list, items, index,estado) {
         //console.log("list",list);
          //console.log("items",items);
          PizarraService.cambiarEstado(items[0],estado,function(data){
                vm.actualizarCarta(data.carta);
                socket.emit('pizarra:modifycarta', {carta:data.carta});
               
            })
          angular.forEach(items, function(item) { item.selected = false; });
          list.items = list.items.slice(0, index)
                      .concat(items)
                      .concat(list.items.slice(index));
            //console.log("drop",list.items);
          return true;
        }

        vm.addCarta = function(item){
             vm.cartaModal = $uibModal.open({
                  animation: true,
                  ariaLabelledBy: 'modal-title-top',
                  ariaDescribedBy: 'modal-body-top',
                  templateUrl: 'addcarta.html',
                  size: 'md',
                  backdrop:'static',
                  controller: function($scope) {
                    $scope.newCard = {};

                    $scope.uploadFiles = function (files) { 
                        console.log("item",item);
                        if (files && files.length) {
                          for (var i = 0; i < files.length; i++) {
                            Upload.upload({
                                  url: '/backend/pizarra/subirficheros',
                                  data: { file: files[i] }
                              }).then(function (resp) {
                                  //console.log(resp);
                                  if(typeof($scope.newCard.config) == 'undefined'){
                                      $scope.newCard.config = {ficheros:[]};
                                  }
                                  $scope.newCard.config.ficheros.push(resp.data);

                                 if ($scope.newCard.config.ficheros) {
                                  console.log(vm.filesLength = vm.filesLength + 1);
                                  console.log(vm.filesLength);
                                 }
                              }, function (resp) {
                                  //console.log('Error status: ' + resp.status);
                              }, function (evt) {
                                  var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
                                  //console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
                              });
                          }
                          //files = null;

                        }
                    }

                    if(typeof(item)!='undefined'){
                        $scope.newCard = angular.copy(item);
                    }

                    $scope.okForm = function(){
                        console.log("guardando nueva carta", $scope.newCard);
                        PizarraService.nuevaCarta($scope.newCard,function(data){
                            for(var cont=0;cont<data.carta.length;cont++){
                                console.log("SOCKET AVISO",socket);
                                vm.actualizarCarta(data.carta[cont],data.carta[cont].estadopizarra_id);
                                //socket.emit('pizarra:nuevacarta', { carta:data.carta[cont] });
                            }
                            vm.cartaModal.close();
                        });
                    }

                    $scope.koForm = function(){
                        vm.cartaModal.close();
                    }
                   
                  }
              });
        }
    }
  
})();